import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import * as Constants from '../constants';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    login: params => {
        const { username, password } = params;
        const request = new Request(`${Constants.siteUrl}/auth/login/`, {
            method: 'POST',
            body: JSON.stringify({ email: username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ access, user }) => {
                const token = access;
                localStorage.setItem('token', token);
                const userId = user.pk;
                const request = new Request(`${Constants.siteUrl}/users/${userId}/`, {
                    method: 'GET',
                    headers: new Headers({ 'Content-Type': 'application/json', 
                    'Authorization': `Bearer ${token}` }),
                });
                return fetch(request)
                .then(response => {
                    if (response.status < 200 || response.status >= 300) {
                        throw new Error(response.statusText);
                    }
                    return response.json();
                }).then(({id, is_staff, is_superuser, full_name, email}) => {
                    localStorage.setItem('role', (is_staff || is_superuser) ? 'admin' : 'user');
                    localStorage.setItem('user_id', id);
                    localStorage.setItem('full_name', full_name);
                    localStorage.setItem('email', email);
                })
            });
    },
    checkError: error => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    checkAuth: params => {
        return window.location.hash.includes('login') ? Promise.reject() : Promise.resolve();
    },
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        return Promise.resolve();
    },
    getIdentity: () => {
        const role = localStorage.getItem('role');
        const user_id = localStorage.getItem('user_id');
        const full_name = localStorage.getItem('full_name');
        const email = localStorage.getItem('email');
        const token = localStorage.getItem('token');
        return role ? Promise.resolve({'role':role, 'userId': user_id, 'fullName': full_name ? full_name : role, 'email': email, 'token': token}) : Promise.reject();
    },
    // authorization
    getPermissions: params => {
        const role = localStorage.getItem('role');
        return role ? Promise.resolve(role) : Promise.resolve('guest');
    },
};
